import { render, staticRenderFns } from "./LayoutBuilder.vue?vue&type=template&id=6ae61c66&scoped=true"
import script from "./LayoutBuilder.vue?vue&type=script&lang=js"
export * from "./LayoutBuilder.vue?vue&type=script&lang=js"
import style0 from "./LayoutBuilder.vue?vue&type=style&index=0&id=6ae61c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae61c66",
  null
  
)

export default component.exports